/**
 * Tags domain API (Spec 059, E2). Moved bitgleich from the former monolithic `api.ts` — no
 * behavior change (E5).
 */
import type { ApiCore } from './core';

/** A distinct user tag with the number of documents carrying it (#238). */
export interface UserTagCount {
  tag: string;
  count: number;
}

export class TagsApi {
  constructor(private readonly core: ApiCore) {}

  /**
   * Update user-defined tags for a document.
   */
  async updateUserTags(id: string, userTags: string[]): Promise<void> {
    return this.core.fetchVoid(`${this.core.baseUrl}/api/v1/documents/${id}/user-tags`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        ...this.core.getAuthHeaders(),
      },
      body: JSON.stringify(userTags),
    });
  }

  /**
   * Distinct user tags (with document counts) for the given household scope (#238).
   * householdId omitted → across all households (ADR-046).
   */
  async getUserTags(householdId?: string): Promise<UserTagCount[]> {
    const qs = householdId ? `?householdId=${encodeURIComponent(householdId)}` : '';
    const response = await this.core.fetchJson<{ tags: UserTagCount[] }>(
      `${this.core.baseUrl}/api/v1/documents/user-tags${qs}`,
      { headers: this.core.getAuthHeaders() },
    );
    return response.tags;
  }
}
